/** Site-wide config placeholders — fill in real values on merge into Prod. */
export const DISCORD_INVITE_URL = '#' // TODO: set real Discord invite before launch

/**
 * Primary nav — static fallback, overridden by siteContent.nav.links when an
 * admin has configured one (see Nav.jsx). Mirrors Prod's real default set
 * (Shop / Hall of Fame / FAQ) plus the revamp's own Best Sellers anchor.
 */
export const NAV_LINKS = [
  { to: '/catalog', label: 'Shop' },
  { to: '/#best-sellers', label: 'Best Sellers' },
  { to: '/#hall-of-fame', label: 'Hall of Fame' },
  { to: '/#faq', label: 'FAQ' },
]

export const HERO_SOCIAL_PROOF = {
  rating: '4.9/5',
  reviewers: 'From 2,000+ customers',
  avatars: [{ image: '', link: '' }, { image: '', link: '' }, { image: '', link: '' }, { image: '', link: '' }],
}

/** Floating info panel pinned to the hero visual's edge. */
export const HERO_INFO_PANEL = [
  { icon: 'flask', title: 'Research Grade', subtitle: '99%+ Purity' },
  { icon: 'shield', title: 'Trusted Source', subtitle: 'Third-Party Tested' },
  { icon: 'lock', title: 'Discreet Shipping', subtitle: 'Private. Secure. Fast.' },
  { icon: 'doc', title: 'Lab Verified', subtitle: 'Quality You Can Trust' },
]

/** Bottom trust bar — one continuous divided strip. `icon` keys map to Hero.jsx's icon set. */
export const FEATURE_BAR = [
  { icon: 'lock', title: 'Discreet & Secure', subtitle: 'Private packaging, zero branding.' },
  { icon: 'globe', title: 'Worldwide Shipping', subtitle: 'Fast & reliable delivery wherever you are.' },
  { icon: 'badge', title: 'Research Only', subtitle: 'For laboratory research purposes.' },
  { icon: 'shield-check', title: 'Quality Assured', subtitle: 'Rigorous testing for every batch.' },
]
